import { StyledText } from 'src/components/foundations/foundations.styles';
import styled from 'styled-components';

export const SearchFieldDescription = styled(StyledText)`
  margin: 10px 0 20px 0;
`;
